import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="scroll-position"
export default class extends Controller {
  static targets = ['scrollable']

  scrollableTargetConnected = (element) => {
    element.addEventListener('click', this.saveScrollPosition)
  }

  scrollableTargetDisconnected = (element) => {
    element.removeEventListener('click', this.saveScrollPosition)
  }

  connect = () => {
    setTimeout(() => this.restoreScrollPosition(), 100)
  }

  saveScrollPosition = () => {
    const scrollPosition = this.element.scrollTop
    sessionStorage.setItem('printProductsScrollPosition', scrollPosition)
  }

  restoreScrollPosition = () => {
    const savedPosition = sessionStorage.getItem('printProductsScrollPosition')

    if (savedPosition !== null && parseInt(savedPosition) > 0) {
      const targetPosition = parseInt(savedPosition)
      this.animateScrollTo(targetPosition)

      // Clear the saved position after starting the animation
      sessionStorage.removeItem('printProductsScrollPosition')
    }
  }

  animateScrollTo(targetPosition) {
    const scrollElement = this.element
    const startPosition = scrollElement.scrollTop
    const distance = targetPosition - startPosition

    // No need to animate if we're already there or very close
    if (Math.abs(distance) < 10) {
      scrollElement.scrollTop = targetPosition
      return
    }

    // Calculate animation parameters
    const duration = Math.min(2000, Math.abs(distance) * 2) // Faster for smaller distances
    const startTime = performance.now()

    // Animation function
    const animateScroll = (currentTime) => {
      const elapsedTime = currentTime - startTime
      const progress = Math.min(elapsedTime / duration, 1)

      // Use easeOutCubic easing function for smoother deceleration
      const easedProgress = 1 - Math.pow(1 - progress, 3)

      // Calculate and set new position
      const newPosition = startPosition + distance * easedProgress
      scrollElement.scrollTop = newPosition

      // Continue animation if not done
      if (progress < 1) {
        requestAnimationFrame(animateScroll)
      }
      else {
        // Ensure we end at exactly the target position
        scrollElement.scrollTop = targetPosition
      }
    }

    // Start animation
    requestAnimationFrame(animateScroll)
  }
}
